import React from 'react'
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import ModuleDynamicFilterDropdown from '../../../../UI/modules/views/partials/common/ModuleDynamicFilterDropdown';
import ModuleRecordsPerPageDropdown from '../../../../UI/modules/views/partials/common/ModuleRecordsPerPageDropdown';
import ModuleSearchBox from '../../../../UI/modules/views/partials/common/ModuleSearchBox';
import ModuleStatusDropdown from '../../../../UI/modules/views/partials/common/ModuleStatusDropdown';

const SearchArea = ({ moduleConfig, setFilter, appliedFilters, resetFilters }) => {
    //console.log(appliedFilters);
    return (
        <div className="position-relative">
            {/* {
                (
                    (appliedFilters.limit)
                    || (appliedFilters.q)
                    || (appliedFilters.status)
                    || (appliedFilters.role)
                    || (appliedFilters.accountDeleted)
                    || (appliedFilters.isBoardMember)
                    || (appliedFilters.profilesType)
                    || (appliedFilters.blockedByAdmin)
                    || (appliedFilters.expiryStatus)
                    || (appliedFilters.profilesType)
                ) &&
                <div div className="resetFilters member text-right " onClick={() => resetFilters()}>
                    <span>
                        <i className="fas fa-times" /> Reset Filters
                    </span>
                </div>
            } */}
            <Card className="listingPageHeader p-0 m-0 p-0 px-1 pt-1 mt-0 mb-1">
                <Card.Body className=" p-0 m-0">



                    <Row className="mb-0">

                        {
                            (moduleConfig.hasPagination === true && moduleConfig.perPageItemsOptions && moduleConfig.perPageItemsOptions.length > 0) &&
                            <Col className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-0">
                                <ModuleRecordsPerPageDropdown
                                    selectedPerPageItems={moduleConfig.perPageItems}
                                    perPageItemsOptions={moduleConfig.perPageItemsOptions}
                                    setFilter={setFilter}

                                />
                            </Col>
                        }
                        <Col className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
                            <ModuleDynamicFilterDropdown
                                filterField='role'
                                setFilter={setFilter}
                                appliedFilters={appliedFilters}
                                options={[
                                    {
                                        label: "Select Role...",
                                        value: "all"
                                    },
                                    {
                                        label: "Board Member",
                                        value: "Board Member"
                                    },
                                    {
                                        label: "Club Vice President",
                                        value: "Club Vice President"
                                    },
                                    {
                                        label: "Club President",
                                        value: "Club President"
                                    },
                                    {
                                        label: "Normal Member",
                                        value: "Member"
                                    },
                                ]}
                            />
                        </Col>


                        <Col className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
                            <ModuleDynamicFilterDropdown
                                filterField='profilesType'
                                setFilter={setFilter}
                                appliedFilters={appliedFilters}
                                options={[
                                    {
                                        label: "Select Profiles Types...",
                                        value: "all"
                                    },
                                    {
                                        label: "Admin Created Profiles",
                                        value: "admin-created-profiles"
                                    },
                                    {
                                        label: "Signup Profiles",
                                        value: "signup-profiles"
                                    },
                                    {
                                        label: "Migrated Profiles",
                                        value: "migrated-profiles"
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                    <Row >

                        {
                            (moduleConfig.hasStatusSearch === true) &&
                            <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 mt-1 mb-1 pt-2">
                                <ModuleStatusDropdown
                                    setFilter={setFilter}
                                    appliedFilters={appliedFilters}
                                    statusOptions={[
                                        {
                                            label: "Select Membership Status...",
                                            value: "all"
                                        },
                                        {
                                            label: "Signup Request - Email Verification Required",
                                            value: "EmailVerificationRequired"
                                        },
                                        {
                                            label: "Signup Request - Admin Action Required",
                                            value: "SignupRequest"
                                        },
                                        {
                                            label: "Signup Request - Rejected",
                                            value: "SignupRequestRejected"
                                        },
                                        {
                                            label: "Signup Request Accepted - Registration Payment Pending",
                                            value: "RegistrationPaymentPending"
                                        },
                                        {
                                            label: "Active Members",
                                            value: "ActiveMembers"
                                        },
                                        {
                                            label: "Renewed Members",
                                            value: "RenewedMembers"
                                        },
                                        {
                                            label: "Member(s) Joined This Year",
                                            value: "JoinedThisYear"
                                        },
                                        {
                                            label: "Members Expiring Soon",
                                            value: "ExpiringSoon"
                                        },
                                        {
                                            label: "Members in Tolerance Period",
                                            value: "TolerancePeriod"
                                        },
                                        {
                                            label: "Expired Members",
                                            value: "ExpiredMembers"
                                        },
                                        {
                                            label: "Blocked Members",
                                            value: "BlockedMembers"
                                        },
                                        {
                                            label: "Archived Members",
                                            value: "ArchivedMembers"
                                        },
                                        {
                                            label: "Account Deletion Requested Members",
                                            value: "AccountDeleteRequests"
                                        },
                                    ]}

                                />
                            </Col>
                        }

                        {
                            (moduleConfig.hasSearch === true) &&

                            <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 mt-1 mb-1 pt-2">
                                <ModuleSearchBox
                                    setFilter={setFilter}
                                    appliedFilters={appliedFilters}
                                />
                            </Col>

                        }
                    </Row>


                </Card.Body>
            </Card>

        </div>



    )
}

export default SearchArea